export default __webpack_public_path__ + "static/media/ART18.de158044.jpg";